import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import { PATH_WORKFLOW_TASKS } from '@/lib/constants/api'
import buildInitialState from '@/store/helpers/buildInitialState'
import createPaginatedGetAction from '@/store/helpers/createPaginatedGetAction'
import updateStatus from '@/store/helpers/updateStatus'
import { notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const workflowTasks = {
  namespaced: true,
  state: buildInitialState({
    workflowTaskList: [],
    totalRecords: 0
  }),
  getters: {
    getField
  },
  actions: {
    getWorkflowTasksWithFilters ({ dispatch, rootGetters }) {
      return dispatch('getWorkflowTasks', { ...rootGetters['workflowTaskFilters/getSearchObject'] })
    },
    getWorkflowTasksWithFiltersPaginated ({ dispatch, rootGetters }, paginationParams = {}) {
      return dispatch('getWorkflowTasksPaginated', {
        ...rootGetters['workflowTaskFilters/getSearchObject'],
        ...paginationParams
      })
    },
    getWorkflowTasks ({ commit, dispatch }, filters = {}) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Loading tasks, please wait...' })

      return api.doGet({ path: PATH_WORKFLOW_TASKS, parameters: filters })
        .then(json => json.data)
        .then(tasks => {
          commit('updateStatus', { status: COMPLETE })
          commit('setWorkflowTasks', tasks)
          return tasks
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to load workflow tasks')
          commit('setWorkflowTasks', [])
          return []
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    getWorkflowTasksPaginated: createPaginatedGetAction(PATH_WORKFLOW_TASKS, 'setPaginatedWorkflowTasks', 'Unable to load workflow tasks')
  },
  mutations: {
    updateStatus,
    updateField,
    setWorkflowTasks (state, tasks) {
      state.workflowTaskList = tasks
      state.totalRecords = Array.isArray(tasks) ? tasks.length : 0
    },
    setPaginatedWorkflowTasks (state, { result, totalRecords }) {
      state.workflowTaskList = result
      state.totalRecords = totalRecords
    }
  }
}

export default workflowTasks
